fabric.Canvas.prototype.getItem = function(id) {
    var object = null,
        objects = this.getObjects();
    for (var i = 0, len = this.size(); i < len; i++) {
        if (objects[i].id && objects[i].id === id) {
            object = objects[i];
            break;
        }
    }

    return object;
};

fabric.Canvas.prototype.removeItem = function(id) {
	canvas.getObjects().forEach(function(o) {
        if(o.id === id) {
            canvas.setActiveObject(o);
        }
    });

    var activeObjects = canvas.getActiveObjects();
    canvas.discardActiveObject();
    if (activeObjects.length) {
      canvas.remove.apply(canvas, activeObjects);
    }

    canvasorig.getObjects().forEach(function(o) {
        if(o.id === id) {
            canvasorig.setActiveObject(o);
        }
    });

    var activeObjects = canvasorig.getActiveObjects();
    canvasorig.discardActiveObject();
    if (activeObjects.length) {
      canvasorig.remove.apply(canvasorig, activeObjects);
    }
};

